export default __webpack_public_path__ + "static/media/User-ConTarjetaBlack.52e95a8d.svg";